@let familleLivrables = traductions().familleDeLivrables;
<div [formGroup]="form()">
  <div class="gap-lg grid" formArrayName="famillesLivrables">
    @for (_ of famillesLivrables.controls; track $index; let idx = $index) {
      <app-expansion-panel [titre]="familleLivrables + ' ' + (idx + 1)" [isOpen]="true">
        <div class="m-lg">
          <div hlmField>
            <label [for]="'autocomplete-' + idx" hlmFieldLabel>{{ familleLivrables }}</label>
            <div type="autocomplete" hlmButtonGroup>
              <brn-select class="inline-block" (valueChange)="setReferentiel($event)">
                <hlm-select-trigger>
                  <hlm-select-value>
                    <div *brnSelectValue="let value">
                      {{ value?.nom ?? 'Tous les référentiels' }}
                    </div>
                  </hlm-select-value>
                </hlm-select-trigger>
                <hlm-select-content class="!min-w-max">
                  <hlm-option [value]="undefined">
                    <span>Tous les référentiels</span>
                  </hlm-option>
                  @for (referentiel of _referentiels(); track referentiel.id) {
                    <hlm-option [value]="referentiel">{{ referentiel.nom }}</hlm-option>
                  }
                </hlm-select-content>
              </brn-select>
              <hlm-autocomplete
                [id]="'autocomplete-' + idx"
                [filteredOptions]="famillesLivrablesFiltrees()"
                [formControlName]="idx"
                (searchChange)="filterFamilleLivrables($event)"
                autocompleteSearchClass="border-stroke-neutral-medium"
              />
            </div>
          </div>
        </div>
      </app-expansion-panel>
    }

    @if (form().enabled) {
      <app-button-add-new [label]="'Ajouter une ' + (familleLivrables | lowercase)" (click)="ajouterFamille()" />
    }
  </div>
</div>
